import { render } from "./SejarahView.vue?vue&type=template&id=7a0070d7"
import script from "./SejarahView.vue?vue&type=script&lang=js"
export * from "./SejarahView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__